export default __webpack_public_path__ + "static/media/1012.86cf91f5.svg";